module.exports = ".pic-small {\n  max-width: 64px;\n  max-height: 64px;\n  min-width: 32px;\n  min-height: 32px; }\n\n.pointer {\n  cursor: pointer; }\n\n.overlaping {\n  background-color: #f2dede !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/devices/editScheduleEntries/editScheduleEntries.component.scss
// module id = ./src/app/views/devices/editScheduleEntries/editScheduleEntries.component.scss
// module chunks = main